export default [
  // {
  //   path: '/task-center',
  //   name: 'task-center',
  //   component: () => import(/* webpackChunkName: "task-center" */ './task-center/task-center.vue'),
  //   // meta: {
  //   //   menuCode: 'pcWallet',
  //   // },
  //   meta: {
  //     noCache: true,
  //     menuName: '任务中心',
  //   },
  // },
];
